// @flow
import React from 'react';
import {
  Alert, Col, Modal, Row,
} from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  type: String,
};

const ConfirmationModal = (props: Props) => {
  const {
    visible,
    close,
    submit,
    type,
  } = props;

  const contents = {
    REBOARD: {
      heading: 'Are you sure you want to abandon the existing PayPal account and create a new one?',
      note: 'The current MID will become invalid.',
    },
    UPDATE: {
      heading: 'Are you sure you want to fetch all business details and update them in PayPal?',
      note: 'This will overwrite the existing details in PayPal.',
    },
  };

  const onSubmit = () => {
    submit();
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={onSubmit} type="primary">Confirm</SpButton>,
      ]}
      title="Confirmation"
    >
      <div className="px-4">
        <Row type="flex" justify="start" align="middle" className="mt-3">
          <Col span={24}>
            <SpH5>{contents[type]?.heading}</SpH5>
          </Col>
        </Row>
        <Row type="flex" justify="start" align="middle" className="mt-3">
          <Col span={24}>
            <Alert message={<span><span style={{ fontWeight: '600' }}>Note:</span> {contents[type]?.note}</span>} type="warning" showIcon />
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default ConfirmationModal;
